import { Component, ViewChild,AfterViewInit,ElementRef,Output,EventEmitter,Input } from '@angular/core';
import {WsService} from '../../utils/network/ws.service';
import {Modal} from 'ng2-modal';
import {MediaService}  from '../peers/media.service';
import { RoomManagerService } from '../services/room/room-manager.service';
import { WsService2 } from '../services/ws/ws.service';
@Component({
  selector: "dskl-peer-tools",
  templateUrl: 'peer-tools.component.html',
styles:[`.panel {
  width:170px;
  margin-bottom:0px;
}
`]
})
export class PeerToolsComponent {
  constructor(private mediaService: MediaService, private wsService: WsService2, private roomManager: RoomManagerService){}
  @Output() onLayout = new EventEmitter();
  @Input() peers=[];
  mutedmic=false;
  mutedvideo=false;
  mute(b){
    this.mediaService.mic(this.mutedmic) 
      this.mutedmic= !this.mutedmic;
      
  }
  
  raiseHand(p=null){
    if (!p){
      p = this.roomManager.getPeers()[this.wsService.getMe()];
      
    }
    if (typeof p.raised=='undefined'){
      p.raised = false;
    }
    this.roomManager.raiseHand(p.who, !p.raised);
    //this.wsService.send("raiseHand",{raised: this.raised});
  }
  video(b){
    this.mediaService.video(this.mutedvideo)
    this.mutedvideo = !this.mutedvideo; 
    
  }
  
  
}



// WEBPACK FOOTER //
// /app/src/app/wb/tools/peer-tools.component.ts